import { useCallback } from 'react';
import Message from '@meitu/saas-ui/es/message';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { useStoreState } from '@/store';
import useAddUploadLayer from './use-add-upload-layer';
import useFilesUpload, { saveMyPictureByUrl } from './use-files-upload';

export const useDropImageToStage = () => {
    const { $t } = useLocaleStore();
    const isBackgroundOperation = useStoreState((state) => state.editorModel.isBackgroundOperation);
    const { filesUpload } = useFilesUpload();

    const { handleAddUploadLayer } = useAddUploadLayer();
    const dropImageToStage = useCallback(
        async (files: any, byMousePosition?: boolean, shouldSaveMyPicture = true, trackFunc?: string) => {
            if (isBackgroundOperation) return;
            try {
                if (!files?.length) return;
                if (files.length > 10) {
                    Message.info($t((v) => v.hooks.uploadMaxLimit));
                    return false;
                }
                editor.tip.showMask({ loading: true });
                const lists = await filesUpload(files, '', false);
                for (let index = 0; index < lists.length; index++) {
                    const { url, width, height, svgInfo, mediaLayerInfo } = lists[index];
                    const image = {
                        url,
                        width,
                        height,
                        ext: mediaLayerInfo ? JSON.stringify(mediaLayerInfo) : svgInfo,
                    };

                    await handleAddUploadLayer({
                        image,
                        trackFunc,
                        byMousePosition,
                        fixedCenter: true,
                    });

                    if (shouldSaveMyPicture) {
                        saveMyPictureByUrl(lists[index]);
                    }
                }
            } catch (error) {
                console.log(error);
                editor.tip.hideMask();
            } finally {
                editor.tip.hideMask();
            }
        },
        [isBackgroundOperation],
    );

    return dropImageToStage;
};
